var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-cell',{staticClass:"w-px",attrs:{"href":_vm.href}},[_c('icon',{staticClass:"block w-6 h-6 fill-gray-400",attrs:{"name":"cheveron-right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }